import { cn } from "@/lib/utils"
import type { ScreenshotSource } from "@/types/site"

// Deterministic warm gradient per host, for sites still waiting on the worker.
function placeholderHue(host: string) {
  let hash = 0
  for (const char of host) hash = (hash * 31 + char.charCodeAt(0)) | 0
  return Math.abs(hash) % 360
}

export function Screenshot({
  src,
  host,
  source,
  alt,
  eager = false,
  className,
}: {
  src: string | null
  host: string
  source?: ScreenshotSource
  alt: string
  eager?: boolean
  className?: string
}) {
  const hue = placeholderHue(host)
  return (
    <div
      className={cn(
        "bg-muted relative aspect-[16/10] w-full overflow-hidden",
        className,
      )}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          width={800}
          height={500}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          className="size-full object-cover object-top"
        />
      ) : (
        <div
          className="flex size-full flex-col items-center justify-center gap-2"
          style={{
            background: `linear-gradient(135deg, hsl(${hue} 70% 92%), hsl(${(hue + 40) % 360} 65% 82%))`,
          }}
        >
          <span className="font-mono text-sm text-stone-700/80">{host}</span>
          <span className="text-[11px] tracking-wider text-stone-600/70 uppercase">
            Screenshot on the way
          </span>
        </div>
      )}
      {source === "wayback" && (
        <span className="absolute bottom-2 left-2 rounded bg-black/65 px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white uppercase backdrop-blur-sm">
          From the Wayback Machine
        </span>
      )}
    </div>
  )
}
